var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoDomicilio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 29,
    viewBox: "0 0 46 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"Motor Scooter\""
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6582 23.0004C15.5355 22.9946 15.3989 22.9893 15.2474 22.9847C14.3583 22.9578 13.1562 22.9575 11.4785 22.9575C9.80097 22.9575 8.59885 22.9579 7.7098 22.9848C7.55816 22.9894 7.42162 22.9947 7.29886 23.0005C7.61048 25.0288 9.36309 26.582 11.4785 26.582C13.594 26.582 15.3467 25.0286 15.6582 23.0004ZM11.4785 28.9986C15.1488 28.9986 18.1241 26.0233 18.1241 22.353C18.1241 21.8164 18.1241 21.4388 17.9516 21.173C17.5417 20.5409 16.1568 20.541 11.4785 20.541C4.83301 20.541 4.83301 20.5411 4.83301 22.353C4.83301 26.0233 7.80827 28.9986 11.4785 28.9986Z",
    fill: "#DCB342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3876 18.1242H21.7491V20.5407H28.0792L28.3876 18.1242ZM19.3325 15.7076V22.9573H30.207L31.1321 15.7076H19.3325Z",
    fill: "#DCB342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3918 6.04139H36.2485V16.9159H33.832V8.45795H32.4389L30.1907 21.9477L27.807 21.5504L30.3918 6.04139Z",
    fill: "#DCB342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9074 23.148C34.3463 25.442 36.5617 26.9458 38.8557 26.5068C41.1498 26.068 42.6536 23.8525 42.2146 21.5585L44.5882 21.1044C45.2779 24.7092 42.9147 28.1906 39.3099 28.8804C35.705 29.5701 32.2236 27.2069 31.5338 23.6021L33.9074 23.148Z",
    fill: "#DCB342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0716 20.241C42.6771 19.3047 42.0248 18.4896 41.1794 17.8976C39.998 17.0704 38.5366 16.7465 37.1164 16.9969C35.6963 17.2472 34.4338 18.0516 33.6067 19.2328C33.0147 20.0783 32.6803 21.0674 32.6301 22.0821L43.0716 20.241ZM43.625 22.5972L32.9158 24.4856C31.6744 24.7045 30.1955 23.8698 30.207 22.2942C30.2186 20.7132 30.7076 19.1602 31.6272 17.8468C32.8219 16.1405 34.6455 14.9787 36.6968 14.617C38.7482 14.2553 40.8592 14.7234 42.5654 15.9181C43.8788 16.8376 44.8694 18.1299 45.421 19.6116C45.9707 21.0881 44.8664 22.3784 43.625 22.5972Z",
    fill: "#DCB342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3323 8.45795H8.45784C7.79051 8.45795 7.24956 8.9989 7.24956 9.66623V10.8745H20.5406V9.66623C20.5406 8.9989 19.9997 8.45795 19.3323 8.45795ZM8.45784 6.04139C6.45585 6.04139 4.83301 7.66423 4.83301 9.66623V12.0828C4.83301 12.7501 5.37398 13.2911 6.04129 13.2911H21.7489C22.4162 13.2911 22.9572 12.7501 22.9572 12.0828V9.66623C22.9572 7.66423 21.3343 6.04139 19.3323 6.04139H8.45784Z",
    fill: "#DCB342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3325 13.2911H11.5458C7.14818 13.2911 3.47674 16.4004 2.61024 20.5407H19.3325V13.2911ZM11.5458 10.8745C5.16922 10.8745 0 16.0438 0 22.4203C0 22.7168 0.240423 22.9573 0.537007 22.9573H19.3325C20.6671 22.9573 21.749 21.8754 21.749 20.5407V11.8411C21.749 11.3073 21.3162 10.8745 20.7824 10.8745H11.5458Z",
    fill: "#DCB342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2483 2.41656H33.2276C32.2267 2.41656 31.4152 3.22804 31.4152 4.22897C31.4152 5.22991 32.2267 6.04139 33.2276 6.04139H36.2483V2.41656ZM33.2276 0C30.892 0 28.9987 1.89337 28.9987 4.22897C28.9987 6.56458 30.892 8.45795 33.2276 8.45795H37.9213C38.332 8.45795 38.6649 8.12507 38.6649 7.71437V0.743575C38.6649 0.332881 38.332 0 37.9213 0H33.2276Z",
    fill: "#DCB342"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M24.3746 2.39831C24.4902 1.74113 25.1165 1.30192 25.7738 1.41743L29.3439 2.04489C30.0012 2.1604 30.4403 2.78677 30.3248 3.44408C30.2093 4.10126 29.5829 4.54047 28.9256 4.42496L25.3555 3.7975C24.6983 3.68199 24.2591 3.05561 24.3746 2.39831Z",
    fill: "#DCB342"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDomicilio);
export default __webpack_public_path__ + "static/media/icoDomicilio.157102dc7f38f7bc624db08e2858b794.svg";
export { ForwardRef as ReactComponent };